import { ProductService } from "@/services/nextshop/product.service"
import { getStorageItemNotParse, getStorageItem, getLocationID } from '@/utils/auth'
import { SettingService } from "@/services/nextshop/setting.service"

export default {
  methods: {
    getParamPos() {
      let dataPos = getStorageItem('POS')
      let pos_id = getStorageItem('POS_ID')
      const _index = dataPos.length > 0 ? dataPos.findIndex((item) => item.id == pos_id) : -1
      let itemPos = dataPos[_index] ? dataPos[_index] : []
      if(itemPos.listItemCart && itemPos.listItemCart.length > 0){
        const inforAccount = getStorageItem("auth.currentUser")
        const locationId = getLocationID("LID")

        const totalAmountCart = this.checkNumReplaceComma(itemPos.totalAmountCart)
        const formatTax = this.checkNumReplaceComma(itemPos.taxOrder) / 100

        const formatDiscountOrder =
          typeof itemPos.discountOrder == "number" &&
          itemPos.selecTypeInput === "%"
            ? (totalAmountCart * itemPos.discountOrder) / 100
            : typeof itemPos.discountOrder == "number" &&
            itemPos.selecTypeInput === "đ"
            ? itemPos.discountOrder
            : typeof itemPos.discountOrder == "string" &&
            itemPos.selecTypeInput === "%"
              ? (totalAmountCart * parseInt(itemPos.discountOrder)) / 100
              : this.checkNumReplaceComma(itemPos.discountOrder)

        const formatOrtherService = this.checkNumReplaceComma(itemPos.ortherService)

        const param = {
          locationId: locationId,
          targetMethod: this.getSavePos ? "NEXT_SHOP_POS_WEB_ENABLE_DRAFT" : "NEXT_SHOP_POS_WEB",
          targetService: "NEXT_SHOP",
          targetServiceType: "NEXT_SHOP",
          addFees: [
            {
              amount: parseInt(((totalAmountCart - formatDiscountOrder) * formatTax).toFixed()),
              cat: "TAX_ALL",
              key: "TAX_ALL",
              name: "Thuế trên tổng đơn hàng",
              extraData: {
                checkBox: itemPos.checkBoxTaxOrder,
                value: itemPos.taxOrder,
              }
            },
            {
              amount: 0 - parseInt(formatDiscountOrder.toFixed()),
              cat: "DISCOUNT_ALL",
              key: "DISCOUNT_ALL",
              name: "Khuyến mại trên tổng đơn hàng"
            },
            {
              amount: formatOrtherService,
              cat: "OTHER_FEE",
              key: "OTHER_FEE",
              name: "Phí khác"
            }
          ],
          currency: "VND",
          note: itemPos.noteOrder,
          partyA: {
            title: "Nhân viên bán",
            displayName: inforAccount.name,
            phoneNo: inforAccount.phone != "" ? inforAccount.phone : null,
            address: inforAccount.address != "" ? inforAccount.address : "",
            role: "SELLER"
          },
          furtherInstructions: [
            {
              key: "EMPLOYEE",
              cat: "NSH_SELLER",
              note: "EMPLOYEE",
              params: {
                employeeId:
                  inforAccount.userId != "" ? inforAccount.userId : "",
                employeeName:
                  inforAccount.name != "" ? inforAccount.name : "",
                employeePhone:
                  inforAccount.phone != "" ? inforAccount.phone : null,
                employeeAddress:
                  inforAccount.address != ""
                    ? inforAccount.address
                    : ""
              }
            }
          ],
          partyB: itemPos.partyB,
          lineItem: itemPos.listItemCart.map((e) => {
            //Gia 1 san pham
            let amount = this.checkNumReplaceComma(e.amount)

            //Tính perthoundsand
            //Nếu type la % > 0 thi perThousand =  gia tri nhap * 10, amount = 0
            //Nếu type la đ > 0 thi perThousand = 0, amount = gia tri nhap

            let discountPerThoundSand = 0
            if (e.typeDiscount === "%") {
              discountPerThoundSand = this.checkNumReplaceComma(e.discount)
            }
            if (e.typeDiscount === "đ") {
              if (typeof e.discount == "number") {
                if (amount == 0) {
                  discountPerThoundSand = 0
                }
                if (amount != 0) {
                  discountPerThoundSand = parseInt(
                    ((e.discount * 100) / amount).toFixed()
                  )
                }
              }
              if (typeof e.discount == "string") {
                if (amount == 0) {
                  discountPerThoundSand = 0
                }
                if (amount != 0) {
                  discountPerThoundSand = parseInt(
                    (
                      (parseInt(e.discount.replace(/,/g, "")) * 100) /
                      amount
                    ).toFixed()
                  )
                }
              }
            }

            //Quy đổi % chiêt khấu ra đ = (giá sp * chiết khấu)/100
            let discount = 0
            if (e.typeDiscount === "%") {
              if (typeof e.discount == "number") {
                discount = (amount * e.discount) / 100
              }
              if (typeof e.discount == "string") {
                discount = (amount * parseInt(e.discount)) / 100
              }
            }
            if (e.typeDiscount === "đ") {
              discount = this.checkNumReplaceComma(e.discount)
            }

            let taxPerThoundSand = this.checkNumReplaceComma(e.tax)

            //Quy đổi % thuế ra đ = (giá sp - chiết khấu)*(thuế)/100
            let discount_perThousand = 0
            let discount_amount = 0

            if (e.typeDiscount === "%") {
              discount_perThousand =
                isNaN(discountPerThoundSand) ? 0 : discountPerThoundSand * 10
              discount_amount = 0
            }
            if (e.typeDiscount === "đ") {
              discount_perThousand = 0
              discount_amount = discount
            }
            return {
              ...e,
              amount_init: amount,
              quantity: (e.quantity) ? e.quantity : 0,
              discount: [
                {
                  perThousand: discount_perThousand,
                  amount: discount_amount
                },
              ],
              tax: [
                {
                  perThousand: taxPerThoundSand * 10,
                  amount: 0
                },
              ]
            }
          })
        }

        //Phi ship bao khach
        if(itemPos.isDiliveryLast){
          
          param.isDiliveryLast = itemPos.isDiliveryLast
          param.dloInfo = itemPos.dloInfo

          const addFeesShipping = {
            "amount": (itemPos.dloInfo.addFeesShipping && itemPos.dloInfo.addFeesShipping.amount) ? this.checkNumReplaceComma(itemPos.dloInfo.addFeesShipping.amount) : 0,
            "cat": "SHIPPING_FEE",
            "key": "SHIPPING_FEE",
            "name": "Phí ship báo khách"
          }
          param.addFees.push(addFeesShipping)
          delete param.dloInfo.addFeesShipping

          param.dloInfo.shippingFee = this.checkNumReplaceComma(itemPos.dloInfo.shippingFee)

        }else{
          delete param.dloInfo
        }
      
        return param
      }  
    },
    nameWithUpc({ name, upc, sku}) {
      return `${name} ${upc} ${sku}`
    },
    getStockQuantityVari(variation) {
      const inventoryID = getStorageItemNotParse("inventoryID")
      variation.stockQuantity = 0
      if (variation.stockQuantities.length > 0) {
        let result = variation.stockQuantities.find((e) => (e.type === "NSH_ITEM_SALE" || e.type === "NSH_ITEM_SALE_NEGATIVE"))
        if(result != undefined) {
          if(result.inventoryDatas){
            result.inventoryDatas.map((stock)=>{
              if(stock.inventoryId === inventoryID){
                return variation.stockQuantity += (stock.quantity) ? stock.quantity : 0
              }
            })
          }
        }
      }
      return variation
    },
    getStockQuantityVariCount(lineItem) {
      const inventoryID = getStorageItemNotParse("inventoryID")
      lineItem.stockQuantity = 0
      if (lineItem.variations.length > 0) {
        lineItem.variations.map((item)=>{
          if(item.stockQuantities.length > 0){
            let result = item.stockQuantities.find((e) => (e.type === "NSH_ITEM_SALE" || e.type === "NSH_ITEM_SALE_NEGATIVE"))
            if(result != undefined) {
              if(result.inventoryDatas){
                result.inventoryDatas.map((stock)=>{
                  if(stock.inventoryId === inventoryID){
                    return lineItem.stockQuantity += (stock.quantity) ? stock.quantity : 0
                  }
                })
              }
            }
          }
        })
      }
      return lineItem
    },
    async getProductSeries(sku){
      const inventoryID = getStorageItemNotParse("inventoryID")
      const params = {
        queryString : "{inventoryId}=='''"+inventoryID+"''' and {sku}=='''"+sku+"''' and {serieStatus}=='''IN_STOCK''' and {isLocked}==false",
        limit :1000,
        lastIndex  : ""
      }
      const dataRes = await ProductService.getProductSeriesEmei(params)
      const listSeri = []
      dataRes.data.data.map((e) => {
        listSeri.push({ id: e.serieNo, text: e.serieNo })
      })

      return listSeri
    },
    formatMoneyNumbers(val) {
      let minus = false
      if (val) {
        if (Math.sign(val) === -1) {
          minus = true
          val = -val
        }
        val = val.toString().split(",").join("")
        let output = ""
        if(val){
          while (val.length >= 3) {
            const last3Digits = val.slice(val.length - 3, val.length)
            val = val.slice(0, val.length - 3)
            output = "," + last3Digits + output
          }
        }
        if (val.length === 0) {
          output = output.slice(1, output.length)
        } else {
          output = val + output
        }
        return (minus ? "-" + output : output) + ""
      } else return "0"
    },
    async addVarForListCart(variation, idItem, useImeiAndSerial, useProductBatch) {

      const inventoryID = getStorageItemNotParse("inventoryID")
      
      /*  
      let getSeri = []
      if(useImeiAndSerial){
        const sku = (variation.sku) ? variation.sku : ''
        getSeri = (sku != '' && sku != undefined) ? await this.getProductSeries(sku) : []
      }
      */

      let exportPrice = 0
      if(variation.prices.length > 0){
        variation.prices.map((vl,idx)=>{
          if(vl.priceTypeCode === 'PRICE_EXPORT'){
            exportPrice = variation.prices[idx].amount
          }
        })
      }
      
      let result = {
        lineItemId: idItem,
        images: variation.images,
        itemInstance: {
          itemId: idItem,
          itemVariationId: variation.variationId,
          _itemVariationId: variation.itemVariationId,
          name: variation.name,
          note: "",
          moreInformation: { sku: variation.sku, name: variation.name },
        },
        quantity: 1,
        unitPrice: exportPrice,
        amount: this.formatMoneyNumbers(exportPrice),
        lineItemOtherInfo: {
          inventoryID: inventoryID,
          seriesNo: null,
          productBatch: null
        },
        seriesNoTmp:[],
        batchTmp:[],
        tax: 0,
        discount: 0,
        typeDiscount: "%",
        totalAmount: 0,
        unit: (variation.unit) ? variation.unit : 'Cái',
        selected: false,
        _showDetails: true,
        useImeiAndSerial: useImeiAndSerial,
        useProductBatch: useProductBatch,
        getSeri: [],
        oneSeri: null,
        stockQuantity: variation.stockQuantity
      }

      //Chon seri default quantity = 0
      if(useImeiAndSerial || useProductBatch){
        result.quantity = 0
      }
  
      result.totalAmount = result.quantity * this.checkNumReplaceComma(result.amount)

      return result
    },
    returnPaymentProcessing(dataPos) {
      return dataPos.paymentInfos.filter((e) => {if (e.status == "SUCCESS") {return e}})
    },
    change(dataPos) {
      const formatPayments = this.checkNumReplaceComma(dataPos.payments)
      dataPos.exchange = formatPayments - dataPos.totalOrder >= 0 ? formatPayments - dataPos.totalOrder : 0
      return dataPos
    },
    customerPay(dataPos) {
      dataPos.payments = dataPos.paymentInfos.reduce(
        (acc, obj) => {
          if (obj.status == "SUCCESS") {
            return Number(acc) + Number(obj.amount);
          } else {
            return Number(acc) + 0;
          }
        },
        0
      )

      dataPos = this.change(dataPos)

      return dataPos
    },
    increase(dataPos, index) {
      if(!dataPos.listItemCart[index].useImeiAndSerial){
        dataPos.listItemCart[index].quantity = dataPos.listItemCart[index].quantity + 1
        dataPos.listItemCart[index].totalAmount += this.checkNumReplaceComma(dataPos.listItemCart[index].amount)
      }
      return dataPos
    },
    caculateMoneyForPos(dataPos) {
      let totalAmountCart = 0
      dataPos.listItemCart.map((e) => {totalAmountCart += e.totalAmount})
      const formatTax =
        typeof dataPos.taxOrder == "number"
          ? dataPos.taxOrder / 100
          : parseInt(dataPos.taxOrder) / 100;
      const formatDiscountOrder =
        typeof dataPos.discountOrder == "number" &&
        dataPos.selecTypeInput === "%"
          ? (totalAmountCart * dataPos.discountOrder) / 100
          : typeof dataPos.discountOrder == "number" &&
          dataPos.selecTypeInput === "đ"
          ? dataPos.discountOrder
          : typeof dataPos.discountOrder == "string" &&
          dataPos.selecTypeInput === "%"
            ? (totalAmountCart * parseInt(dataPos.discountOrder)) / 100
            : parseInt(dataPos.discountOrder.replace(/,/g, ""));

      const formatOrtherService = this.checkNumReplaceComma(dataPos.ortherService)
      
      dataPos.totalAmountCart = parseInt(totalAmountCart)
     
      const firstTotalOrder = dataPos.totalOrder

      dataPos.totalOrder =
        parseInt(
          ((totalAmountCart - formatDiscountOrder) * (1 + formatTax)).toFixed()
        ) + formatOrtherService;
      const totalPayment = dataPos.totalOrder;

      dataPos.payments =
        firstTotalOrder !== totalPayment ? totalPayment : firstTotalOrder;

      const formatPayments = this.checkNumReplaceComma(dataPos.payments);

      dataPos.exchange =
        formatPayments - dataPos.totalOrder >= 0 ? formatPayments - dataPos.totalOrder : 0

      if (this.returnPaymentProcessing.length == 0) {
        dataPos.paymentInfos = [
          {
            active: false,
            amount: 0,
            note: "Tiền mặt",
            paymentGateway: "CASH",
            paymentMethod: "CASH",
            status: "NOT_PAYMENT",
          },
        ]
      }
      return dataPos
    },
    async chooseVariation() {
      const dataPos = getStorageItem('POS')
      const pos_id = getStorageItem('POS_ID')
      const _index = dataPos.length > 0 ? dataPos.findIndex((item) => String(item.id) === String(pos_id)) : -1
      const itemPos = dataPos[_index] ? dataPos[_index] : []
      return itemPos
    },
    formatInputNumber(val) {
      val = parseInt(val);
      if (val.toString().slice(0, 1) == "0" && val.toString().length >= 2) {
        val = val.toString().slice(1, 2);
        new Intl.NumberFormat().format(val);
      }
      if (val === "") {
        val = 0;
      }
      return val;
    },
    formatInputQuantity(val) {
      const formatQuantity = this.checkNumReplaceComma(val.quantity);
      const formatAmount = this.checkNumReplaceComma(val.amount);
      const formatDiscount =
        typeof val.discount == "number" && val.typeDiscount === "%"
          ? (formatAmount * val.discount) / 100
          : typeof val.discount == "number" && val.typeDiscount === "đ"
          ? val.discount
          : typeof val.discount == "string" && val.typeDiscount === "%"
          ? (formatAmount * parseInt(val.discount)) / 100
          : parseInt(val.discount.replace(/,/g, ""));

      if (formatQuantity < 1 || isNaN(formatQuantity)) {
        return 1;
      } else if (formatQuantity * formatAmount < formatDiscount) {
        val.discount = 0;
        return val.quantity;
      } else {
        return val.quantity;
      }
    },
    randomMinMax(min, max) {
      return Math.floor(Math.random() * (max - min + 1) ) + min;
    },
    getNumberUnique(){
      const date = new Date()
      return date.getDate() + date.getMonth() + date.getFullYear() + date.getHours() + date.getMinutes() + date.getSeconds() + this.randomMinMax(100, 900)
    },
    getAmountCustomerPayPos(params) {
      let val = 0
      params.map(function (item) {
        if (item.status == "SUCCESS" && item.paymentMethod != 'DEBT_NOTE') {
          val += parseInt(item.amount)
        }  
      })
      return val
    },
    
    //Can thi bo sung them param: checkExpirationDate
    async getProductBatch(sku){
      let queryString = ''
      /*
      if(!checkExpirationDate){
        const expirationDate = '#' + new Date().toISOString() + '#'
        queryString = "{sku}=='''"+sku+"''' and {quantity} > 0 and {expirationDate} >= "+expirationDate
      }else{
        queryString = "{sku}=='''"+sku+"''' and {quantity} > 0"
      }
      */
      queryString = "{sku}=='''"+sku+"''' and {quantity} > 0"
      const params = {
        queryString: queryString,
        limit: 500,
        lastIndex: "",
        sortField: "EXPIRATION_DATE",
        sortValue: "ASC",
        sortExpiration: true
      }
      const dataRes = await ProductService.getProductBatch(params)
      let listBatch = []
      const inventoryID = getStorageItemNotParse('inventoryID')

      dataRes.data.productBatchModelFlat.map((e) => {
        const checkExpirationDate = this.convertIntDateItem(e.expirationDate)
        
        const getDateToday = new Date().toISOString()
        const checkGetDateToday = this.convertIntDateItem(getDateToday)
        const isExpiration = checkGetDateToday > checkExpirationDate ? true : false
        
        if(e.inventoryData.length > 0){
          e.inventoryData.map((_item)=>{
            if(inventoryID != undefined && inventoryID != null && inventoryID == _item.inventoryId){
              e.quantity = _item.quantity
            }
          })
        }

        const oneItem = {
          batchCode: e.batchCode,
          manufactureDate: e.manufactureDate,
          expirationDate: e.expirationDate,
          quantity: e.quantity,
          quantityVal: 0,
          isExpiration: isExpiration
        }
        listBatch.push(oneItem)
      })
      return listBatch
    },
    async getExpiredSale() {
      let expiredSale = false
      const response = await SettingService.getDataMerchant()
      if(response.success) {
        expiredSale = response.data.merchant.expiredSale
      }
      return expiredSale
    },
    async getProductBatchAutoSelectBatch(inventoryId, listItemCart){
      let data = {
        checkBatch: false,
        itemBatch: {}
      }
      if(listItemCart.length > 0){
        let stocks = []
        listItemCart.map((item)=>{
          if(item.useProductBatch){
            data.checkBatch = true
            const quantitySale = item.quantity
            const sku = item.itemInstance.moreInformation.sku
            let productBatch = []
            if(item.quantity > 0 && item.batchTmp.length >= 0){
              item.batchTmp.map((_item)=>{
                 const _tmp = {
                  batchCode:  _item.batchCode,
                  quantity: _item.quantityVal
                }
                productBatch.push(_tmp)
              })
              const one_stocks = {
                quantitySale: quantitySale,
                sku: sku,
                productBatch: productBatch
              }
              stocks.push(one_stocks)
            }
          }
        })
        if(stocks.length > 0){
          const params= {
            inventoryId: inventoryId,
            stocks: stocks,
            saleNegative: true
          }
          const dataRes = await ProductService.getProductBatchAutoSelectBatch(params)
          if(dataRes.success){
            data.itemBatch = dataRes.data.stockResponse
          }
        }  
      }
      return data
    },
    async genAutoSelectBatch(itemBatch){
      let data = []
      itemBatch.map((item)=>{
       if(item.productBatch && item.productBatch.length >0){
          item.productBatch.map((e)=>{
            const itemName = (e.variationName != '') ? e.variationName : e.itemName
            const itemTmp = {
              batchCode: e.batchCode,
              manufactureDate: e.manufactureDate,
              expirationDate: e.expirationDate,
              quantity: e.quantity,
              sku: e.sku,
              itemName: itemName
            }
            data.push(itemTmp)
          })
       }
      })
      return data
    },
    async addShowGenAutoSelectBatch(showGenAutoSelectBatch, dataPos){
      if(dataPos.listItemCart.length > 0){
        dataPos.listItemCart.map((item)=>{
          if(item.useProductBatch){
            const batchTmp = item.batchTmp
            const sku = item.itemInstance.moreInformation.sku
            showGenAutoSelectBatch.map((_item)=>{
              if(_item.sku == sku){
                const batchCode =_item.batchCode
                const quantity =_item.quantity
                const check = (batchTmp.length > 0) ? batchTmp.findIndex((e) => e.batchCode == batchCode) : -1
                if(check != -1){
                  item.batchTmp[check].quantityVal += quantity
                }else{
                  _item.quantityVal = quantity
                  item.batchTmp.push({..._item})
                }
              }
            })
          }
        })
      }
      return dataPos
    },
    checkLessAutoSelectBatch(listItemCart){
      let checkBatch = true
      if(listItemCart.length > 0){
        listItemCart.map((item)=>{
          if(item.useProductBatch){
            const quantitySale = item.quantity
            let quantityVal = 0
            if(quantitySale == 0 && item.batchTmp.length == 0){
              checkBatch = false
            }
            if(quantitySale > 0 && item.batchTmp.length > 0){
             item.batchTmp.map((_item)=>{
              quantityVal += _item.quantityVal
             })
             if(quantityVal > quantitySale){
                checkBatch = false
             }
            }
          }
        })
      }
      return checkBatch
    },
    checkLessSeriSelect(listItemCart){
      let checkBatch = true
      if(listItemCart.length > 0){
        listItemCart.map((item)=>{
          if(item.useImeiAndSerial){
            if(item.seriesNoTmp.length == 0){
              checkBatch = false
            }
          }
        })
      }
      return checkBatch
    },
  }
}